<template>
  <div id="EleId" class="eee" >
    <Head />
    <div class="owidth cm-main">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          :to="item.path"
          v-for="(item, index) in bcrumb"
          :key="index"
          >{{ item.name }}</el-breadcrumb-item
        >
      </el-breadcrumb> -->
      <button class="back-button" @click="closePage">关闭页面</button>
      <div class="article-content">
        <h1 class="article-title" style="white-space: pre-wrap;">{{ info.title }}</h1>
        <h2 class="article-sub-title">{{ info.refrainTitle }}</h2>
        <!-- <router-link to="" class="article-down-button"
          ><img src="@/assets/icon-download.png" />文件下载</router-link
        > -->
        <p class="article-content-date">
          <span class="riqi">发布日期:
            <span>{{
              $variable.formatDate(
                info.ncReleaseTime || info.shReleaseTime || info.releaseTime
              )
            }}</span>
          </span>
          <span
            >浏览量:
            <span v-if="info.clickNum != undefined">{{ info.clickNum == 0 ? 1 : info.clickNum }}</span>
            <span v-else-if="info.clickNumber != undefined">{{
              info.clickNumber == 0 ? 1 : info.clickNumber
            }}</span>
            <span v-else>1</span>
          </span>
        </p>
        <div
          style="text-indent:2em;"
          v-if="info.contentType != 'PDF文件'"
          class="article content"
          v-html="info.content"
        ></div>
        <iframe
          v-else
          class="pdf-reader"
          :src="`/pdf/web/viewer.html?file=${pdfSrc}`"
        ></iframe>
        <!-- <p class="split-style-1"></p> -->
        <ul class="el-upload-list el-upload-list--text">
          <li
            v-for="(item, index) in reAccessoryArra"
            :key="index"
            class="el-upload-list__item is-success"
          >
            <a
              class="el-upload-list__item-name"
              :href="`${$variable.filePath}${item.url}`"
              ><i class="el-icon-document"></i>
              <span v-if="info.contentType != 'PDF文件'">{{ item.name }}</span>
              <span v-else>下载文件</span>
            </a>
          </li>
        </ul>
        <!-- <div id="pdfReader"></div> -->
      </div>
      <!-- <div class="article-prev-next" style="display: none">
        <p>
          <router-link to=""
            >上一篇：省委编办调研组莅临我办调研组莅临我中心开展专中心开展专题…</router-link
          >
        </p>
        <p>
          <router-link to=""
            >下一篇：省委编办调研组莅办调研组莅临我中临我中心开展专题…</router-link
          >
        </p>
      </div> -->
    </div>
    <Foot />
  </div>
</template>

<script>
import Head from "@/components/head.vue";
import Foot from "@/components/foot.vue";
import {
  getReleaseById,
  getNewsCenterById,
  getSlideshowById,
} from "@/api/api.js";
// import { breadcrumb } from "@/utils/auth.js";
export default {
  components: { Head, Foot },
  data() {
    return {
      is360Se: window.navigator.userAgent.toLowerCase().indexOf("360se") > -1,
      reAccessoryArra: [],
      info: {},
      pdfSrc: "",
      type: this.$route.query.type,
      // bcrumb: localStorage.getItem(breadcrumb)
      //   ? JSON.parse(localStorage.getItem(breadcrumb)).filter((item) => {
      //       return item.name != undefined;
      //     })
      //   : [],
    };
  },
  methods: {
    closePage() {
      window.close();
    },
    getArticleInfo() {
      console.log(222222)
      let aid = this.$route.params.aid;
      let action;
      if (this.type == 1) {
        action = getNewsCenterById;
      } else if (this.type == 2) {
        action = getSlideshowById;
      } else {
        action = getReleaseById;
      }
      action({ id: aid }).then((res) => {
        this.info = res;
        document.title = this.info.title;
        document.columnsId = this.info.columns.id;
        if( document.columnsId == 1571690673894838273 || document.columnsId==1571690102815182850 || document.columnsId==1571690024025182210){

        let lj = this.info.content;
        let a =lj.slice(3,-4)
        window.location.href="http://"+`${a}`;
        }
        // bug改的地方
        if (this.info.reAccessory) {
          let files = this.info.reAccessory.split("|");
          files.forEach((item) => {
            if (item.trim().length > 0) {
              this.reAccessoryArra.push({
                name: decodeURIComponent(
                  item.substring(item.lastIndexOf("/") + 1)
                ),
                url: item,
              });
            }
          });
          if (files.length == 1) {
            if (this.info.contentType == "PDF文件") {
              this.pdfSrc = this.$variable.filePath + files[0];
              // var myPDF = new PDFObject({ url: this.pdfSrc }).embed(
              //   "pdfReader"
              // );
            }
          }
        }
      });
    },

  },

  created() {
    this.getArticleInfo();
    var display = this.$route.params.aid
  },
  watch: {
    $route: {
      handler(val) {},
    },
  },
};
</script>

<style scoped>
/* .article-content {
} */
.article-title {
  padding: 0 60px;
  line-height: 160%;
}
.article-sub-title {
  text-align: center;
  font-size: 22px;
  margin-bottom: 20px;
}
.pdf-reader {
  width: 100%;
  height: 800px;
  border: 1px #ccc solid;
}
.riqi {
  margin-left: -70px;
}

</style>
